// extracted by mini-css-extract-plugin
module.exports = {"removeInnerShadow":"text-area_removeInnerShadow__3Pwbj"};